import React, { useEffect } from "react";

const FontLoader: React.FC = () => {
  useEffect(() => {
    // Helper function to load a single font
    const loadFont = (fontName: string, fontUrl: string, weight: string, style: string = "normal") => {
      const fontFace = new FontFace(fontName, `url(${fontUrl}) format('truetype')`, {
        weight,
        style,
        display: "swap",
      });

      fontFace
        .load()
        .then(loadedFont => {
          document.fonts.add(loadedFont);
        })
        .catch(error => {
          console.error(`Failed to load font ${fontName}`, error);
        });
    };

    // Load fonts here
    loadFont(
      "Roboto Flex",
      `${window.location.origin}/fonts/RobotoFlex-VariableFont_GRAD,XTRA,YOPQ,YTAS,YTDE,YTFI,YTLC,YTUC,opsz,slnt,wdth,wght.ttf`,
      "100 1000"
    );

    // loadFont("Open Sans", `${window.location.origin}/fonts/OpenSans-Regular.ttf`, "400");

    // loadFont("Vikas", `${window.location.origin}/fonts/vikas.ttf`, "400");
  }, []);

  return null; // No jsx returned only to load fonts
};

export default FontLoader;
